import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ErrorFragmentDoc } from '../../fragments/__generated__/Error.generated';
import { CartBaseFragmentDoc, CartTotalPriceFragmentDoc } from '../../fragments/__generated__/Cart.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CartClearMutationVariables = Types.Exact<{
  cartType: Types.CartTypeEnum;
  category?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type CartClearMutation = { cartClear: { success: boolean } };

export type DeleteCartLineMutationVariables = Types.Exact<{
  cartType: Types.CartTypeEnum;
  cartLine?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  variant?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DeleteCartLineMutation = { deleteCartLine: { errors: Array<{ field: string, messages: Array<string> }>, cart: { id: string, token: any, count: number, quantity: number, type: Types.CartTypeEnum, orderId: number | null } | null } };

export type CartLinesUpdateBySupplyMutationVariables = Types.Exact<{
  supplyLineId: Types.Scalars['ID']['input'];
  cartType: Types.CartTypeEnum;
}>;


export type CartLinesUpdateBySupplyMutation = { cartLinesUpdateBySupply: { errors: Array<{ field: string, messages: Array<string> }>, cart: { id: string, token: any } | null } };


export const CartClearDocument = gql`
    mutation CartClear($cartType: CartTypeEnum!, $category: ID) {
  cartClear(cartType: $cartType, category: $category) {
    success
  }
}
    `;
export type CartClearMutationFn = Apollo.MutationFunction<CartClearMutation, CartClearMutationVariables>;

/**
 * __useCartClearMutation__
 *
 * To run a mutation, you first call `useCartClearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartClearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartClearMutation, { data, loading, error }] = useCartClearMutation({
 *   variables: {
 *      cartType: // value for 'cartType'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCartClearMutation(baseOptions?: Apollo.MutationHookOptions<CartClearMutation, CartClearMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartClearMutation, CartClearMutationVariables>(CartClearDocument, options);
      }
export type CartClearMutationHookResult = ReturnType<typeof useCartClearMutation>;
export type CartClearMutationResult = Apollo.MutationResult<CartClearMutation>;
export type CartClearMutationOptions = Apollo.BaseMutationOptions<CartClearMutation, CartClearMutationVariables>;
export const DeleteCartLineDocument = gql`
    mutation DeleteCartLine($cartType: CartTypeEnum!, $cartLine: ID, $variant: ID) {
  deleteCartLine(cartType: $cartType, cartLine: $cartLine, variant: $variant) {
    errors {
      ...Error
    }
    cart {
      ...CartBaseFragment
    }
  }
}
    ${ErrorFragmentDoc}
${CartBaseFragmentDoc}`;
export type DeleteCartLineMutationFn = Apollo.MutationFunction<DeleteCartLineMutation, DeleteCartLineMutationVariables>;

/**
 * __useDeleteCartLineMutation__
 *
 * To run a mutation, you first call `useDeleteCartLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCartLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCartLineMutation, { data, loading, error }] = useDeleteCartLineMutation({
 *   variables: {
 *      cartType: // value for 'cartType'
 *      cartLine: // value for 'cartLine'
 *      variant: // value for 'variant'
 *   },
 * });
 */
export function useDeleteCartLineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCartLineMutation, DeleteCartLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCartLineMutation, DeleteCartLineMutationVariables>(DeleteCartLineDocument, options);
      }
export type DeleteCartLineMutationHookResult = ReturnType<typeof useDeleteCartLineMutation>;
export type DeleteCartLineMutationResult = Apollo.MutationResult<DeleteCartLineMutation>;
export type DeleteCartLineMutationOptions = Apollo.BaseMutationOptions<DeleteCartLineMutation, DeleteCartLineMutationVariables>;
export const CartLinesUpdateBySupplyDocument = gql`
    mutation CartLinesUpdateBySupply($supplyLineId: ID!, $cartType: CartTypeEnum!) {
  cartLinesUpdateBySupply(supplyLineId: $supplyLineId, cartType: $cartType) {
    errors {
      field
      messages
    }
    cart {
      id
      token
    }
  }
}
    `;
export type CartLinesUpdateBySupplyMutationFn = Apollo.MutationFunction<CartLinesUpdateBySupplyMutation, CartLinesUpdateBySupplyMutationVariables>;

/**
 * __useCartLinesUpdateBySupplyMutation__
 *
 * To run a mutation, you first call `useCartLinesUpdateBySupplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartLinesUpdateBySupplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartLinesUpdateBySupplyMutation, { data, loading, error }] = useCartLinesUpdateBySupplyMutation({
 *   variables: {
 *      supplyLineId: // value for 'supplyLineId'
 *      cartType: // value for 'cartType'
 *   },
 * });
 */
export function useCartLinesUpdateBySupplyMutation(baseOptions?: Apollo.MutationHookOptions<CartLinesUpdateBySupplyMutation, CartLinesUpdateBySupplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartLinesUpdateBySupplyMutation, CartLinesUpdateBySupplyMutationVariables>(CartLinesUpdateBySupplyDocument, options);
      }
export type CartLinesUpdateBySupplyMutationHookResult = ReturnType<typeof useCartLinesUpdateBySupplyMutation>;
export type CartLinesUpdateBySupplyMutationResult = Apollo.MutationResult<CartLinesUpdateBySupplyMutation>;
export type CartLinesUpdateBySupplyMutationOptions = Apollo.BaseMutationOptions<CartLinesUpdateBySupplyMutation, CartLinesUpdateBySupplyMutationVariables>;